export default __webpack_public_path__ + "static/media/cabourgmini.62b26da1.jpg";